<template>
  <v-dialog v-model="dialog" width="500" :disabled="loading">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="red darken-1" dark v-bind="attrs" v-on="on" :loading="loading">
        Agregar dirección
      </v-btn>
    </template>

    <v-card>
      <cliente-direcciones-form
        :direccion="direccion"
        :loading="loading"
        @close-dialog="dialog = false"
        @process-save="registrarDireccion"
      ></cliente-direcciones-form>
    </v-card>
  </v-dialog>
</template>

<script>
import ClienteDireccionesForm from "@/components/shared/clientes/direcciones/components/cliente.direccion.form.vue";
import ClienteDireccionesAPI from "@/api/clientes/direcciones.js";
import { mapActions } from 'vuex';


export default {
  name: "DireccionCreate",
  components: {
    ClienteDireccionesForm,
  },
  props: {
    cliente_id: {
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      direccion: {
        barrio: null,
        localidad: null,
        nombre: "",
        calle: "",
        altura: "",
        piso: "",
        depto: "",
        observacionEnvio: "",
        cliente: null
      },
    };
  },
  methods: {
    ...mapActions("clienteDirecciones", ["fetch_direcciones"]),

    registrarDireccion(direccion) {
      direccion.cliente = this.cliente_id;
      this.loading = true;

      ClienteDireccionesAPI.create(direccion)
        .then(() => {
          this.$emit('refresh-direcciones');
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: "Dirección registrada",
            icon: "mdi-check",
            timeout: 2500,
          });
          this.dialog = false;
        })
        .catch((e) => {
          const msg = e.response?.data?.detail || "Error al registrar dirección";
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "error",
            text: msg,
            icon: "mdi-alert",
            timeout: 3000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
